export interface SingleFbbEmail {
	productCharacteristic: {
		name: string;
		value: string;
	};
	name: string;
}

const model: types.models.InputModel = {
	productCharacteristic: 'productRelationship.product.productCharacteristic',
	name: 'productRelationship.product.name',
};

export default model;
